import { extractStringValueSet } from "./extract-properties";

export default class HoldSteps {
    static readonly Accessioning: string = 'accessioning';
    static readonly CuttingInProgress: string = 'cutting-in-progress';
    static readonly SpinningQueue: string = 'spinning-queue';
    static readonly ExtractionInProgress: string = 'extraction-in-progress';
    static readonly QC1InReview: string = 'qc1-in-review';
    static readonly QC1InProgressConcentration: string = 'qc1-in-progress-concentration';
    static readonly SpinningInProgress: string = 'spinning-in-progress';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
